/**
 * Every route pattern the portal renders, mirrored from App.tsx.
 *
 * WHY A LIST INSTEAD OF SANITISING THE URL: analytics must record the route
 * PATTERN ("/clients/:id"), never the concrete path ("/clients/8f3c-..."), or
 * entity ids leak into the event store and every record becomes its own
 * "page". The obvious shortcut — regex-replacing uuid-ish segments — is not
 * safe here, because these params are not all uuids: "/accept-invitation/:token"
 * carries an AUTHENTICATION TOKEN, and "/accountant/client/:tenantId/iva/:period"
 * carries a period string. A regex that only knows about uuids would happily
 * write both into the database.
 *
 * Matching against this list instead makes leakage structurally impossible: a
 * path that matches nothing is recorded as UNKNOWN_ROUTE rather than verbatim.
 * The failure mode of a missing entry is a lost data point, never a leaked one.
 *
 * Kept honest by route-pattern.test.ts, which parses App.tsx and fails if a
 * route exists there but not here.
 */
export const ROUTE_PATTERNS: readonly string[] = [
  "/",
  "/accept-invitation",
  "/accept-invitation/:token",
  "/accountant",
  "/accountant/client/:tenantId",
  "/accountant/client/:tenantId/iva/:period",
  "/accountant/client/:tenantId/onboarding",
  "/accountant/client/:tenantId/subdiario/:period",
  "/accountant/inbox",
  "/accountant/inbox/acks",
  "/accountant/inbox/boletos",
  "/accountant/inbox/obligations",
  "/accountant/new-client",
  "/accountant/profile",
  "/accountant/requests",
  "/accountant/requests/:id",
  "/agenda",
  "/auth/forgot-password",
  "/auth/reset-password",
  "/auth/sso/callback",
  "/auth/verify",
  "/auth/verify-root-invite",
  "/bank-transfer-reviews",
  "/certificate-requests",
  "/certificate-requests/:id",
  "/clients",
  "/clients/:id",
  "/clients/:id/edit",
  "/clients/new",
  "/dashboard",
  "/dgi-documents",
  "/dgi/daily-reports",
  "/dgi/daily-reports/:reportId",
  "/documents",
  "/estado-fiscal",
  "/expenses",
  "/expenses/new",
  "/feedback",
  "/fiscal-status",
  "/homologaciones",
  "/invoices",
  "/invoices/:id",
  "/invoices/:id/credit-note",
  "/invoices/:id/debit-note",
  "/invoices/new",
  "/invoices/recibidas",
  "/invoices/recibidas/:id",
  "/invoices/recurring",
  "/invoices/recurring/:id/edit",
  "/invoices/recurring/new",
  "/login",
  "/onboarding",
  "/onboarding/accountant",
  "/partners",
  "/pay/dlocal-return",
  "/pay/link-not-available",
  "/pay/mercadopago",
  "/pay/thank-you",
  "/platform-analytics",
  "/platform-config",
  "/platform-fiscal-benefit",
  "/platform-metrics",
  "/platform-support",
  "/profile",
  "/profile/edit",
  "/homologaciones/:companyId",
  "/products",
  "/proveedor-software",
  "/register",
  "/reports",
  "/requests",
  "/requests/:id",
  "/settings",
  "/settings/add-company",
  "/suppliers",
  "/suppliers/:id",
  "/suppliers/:id/edit",
  "/suppliers/new",
  "/tenants",
  "/tenants/:id",
  "/tenants/:id/edit",
  "/users",
  "/users/:userId",
  "/users/invites/:inviteId",
  "/verify-email",
];
